export default {
  data() {
    return {
      rulesDefault: {
        required: this.getRequiredRule(),
      },
    };
  },
  computed: {
    getValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    getRules() {
      const newRulesArray = [];
      if (this.required) newRulesArray.push(this.rulesDefault.required);
      return newRulesArray.concat(this.rules);
    },
  },
  methods: {
    onChange() {
      this.getRules.forEach(func => func(this.getValue));
      this.$emit('change');
    },
    onInput(value) {
      this.getValue = value;
    },
    getRequiredRule() {
      return v => !!v || this.$t('support.components.inputs.required');
    },
  },
};
